{
  class readMore extends HTMLParagraphElement {
    constructor() {
      super();
      this.moreText = this.getAttribute('more-text') || 'Read More';
      this.lessText = this.getAttribute('less-text') || 'Read Less';
      this.wordCount = parseInt(this.getAttribute('word-count'), 10) || 40;
      this.overflowIndicator = this.getAttribute('overflow-indicator') || '...';
      this.buttonClass = this.getAttribute('button-class') || ''

      const content = this.textContent.trim().split(/\s+/);

      if (content.length <= this.wordCount) return; // Skip processing if no truncation is needed

      this.fullText = this.textContent.trim();
      this.shortText = content.slice(0, this.wordCount).join(' ') + (content.length > this.wordCount ? this.overflowIndicator : '');
      
      this.expanded = false;
      this.innerHTML = `${this.shortText} <button class='${this.buttonClass}'>${this.moreText}</button>`;
      this.querySelector('button').addEventListener('click', () => this.toggle());
    }

    toggle() {
      this.expanded = !this.expanded;
      this.innerHTML = `${this.expanded ? this.fullText : this.shortText} <button class='${this.buttonClass}'>${this.expanded ? this.lessText : this.moreText}</button>`;
      this.querySelector('button').addEventListener('click', () => this.toggle());
    }
  }

  customElements.define("read-more", readMore, { extends: 'p' })
}